import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 13.5H9s1.5 0 1.5 1.5v6.75s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5V15s0-1.5 1.5-1.5m12.75 0h6.75s1.5 0 1.5 1.5v6.75s0 1.5-1.5 1.5H15s-1.5 0-1.5-1.5V15s0-1.5 1.5-1.5M8.625.75h6.75s1.5 0 1.5 1.5V9s0 1.5-1.5 1.5h-6.75s-1.5 0-1.5-1.5V2.25s0-1.5 1.5-1.5"
    }, null, -1)
  ]));
}
const programmingModuleThree = { render };
export {
  programmingModuleThree as default,
  render
};
//# sourceMappingURL=programming-module-three.svg.js.map
